<template>
  <div>
    <div id="card-container" />

    <div class="flex justify-between items-center q-mt-md q-gutter-sm">
      <a
        class="cursor-pointer opaque-30"
        @click="goToProvider"
      >
        <img
          src="services/square.png"
          style="height: 25px;"
        />
      </a>
      <div class="text-caption text-body1 text-grey-6 text-center">
        Powered by <a class="cursor-pointer text-blue-grey-4" @click="goToProvider">Square</a>
      </div>
    </div>

    <page-banner
      v-if="isDevelopment"
      dense
      icon="mdi-exclamation"
      class="q-mt-md"
      color="orange-3"
    >
      <q-item-label class="text-bold">
        You are running on a Square sandbox environment.
      </q-item-label>
      <q-item-label>Use the following test credit card details:</q-item-label>
      <q-item-label><b>Card Number:</b> 4111 1111 1111 1111</q-item-label>
      <q-item-label><b>Expiry:</b> 12/26</q-item-label>
      <q-item-label><b>CVC:</b> 111</q-item-label>
      <q-item-label><b>ZIP:</b> 77777</q-item-label>
    </page-banner>
  </div>
</template>

<script>
import { markRaw } from 'vue'

export default {
  emits: ['generated'],
  data () {
    return {
      isDevelopment: !!process.env.SANDBOX,
      cardInstance: null
    }
  },
  methods: {
    async makePayment () {
      if (!this.cardInstance) {
        this.$emit('generated', {
          error: { message: 'Failed to connect to Square' }
        })
        return
      }
      const { status, token, errors } = await this.cardInstance.tokenize()

      let errorMessage = ''
      if (status !== 'OK') {
        if (errors.length > 0) {
          errorMessage = errors
        }
        else {
          errorMessage = 'Failed to make payment'
        }
      }

      this.$emit('generated', {
        error: errorMessage || null,
        token: token || null
      })
    },
    async mountProvider () {
      const payments = window.Square.payments(process.env.SQUARE_KEY)
      payments.setLocale('en-AU')
      this.cardInstance = markRaw(await payments.card())
      this.cardInstance.attach('#card-container')
    },
    goToProvider () {
      this.goToHref('https://squareup.com')
    }
  },
  mounted () {
    this.mountProvider()
  }
}
</script>
